import { BaseObject, IBaseObject } from '@uniqoders/sdk';

export interface PaxContract extends IBaseObject {
  guardName: string;
  name: string;
  createdAt: string;
  updatedAt: string;
}

export default class Pax extends BaseObject implements PaxContract {
  public static readonly SUPER_ADMIN = 'super_admin';
  public static readonly ADMIN = 'admin';
  public static readonly USER = 'user';
  public static readonly AGENCY = 'agency';
  public static readonly COLLABORATOR = 'collaborator';
  public static readonly SUPPLIER = 'supplier';

  public declare guardName: string;
  public declare name: string;
  public declare createdAt: string;
  public declare updatedAt: string;

  constructor(data: PaxContract) {
    super(data);
  }
}
